import { subdomains } from "@/common/consts";
// import HomePage from "@/pages/HomePage/HomePage.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";
import CcpaPage from "@/pages/Ccpa/CcpaPage.vue";
import CookiePolicy from "@/pages/CookiePolicy/CookiePolicy.vue";

export default [
    {
        path: "/",
        name: "HomePage",
        meta: {
            subdomain: subdomains.WWW
        },
        component: () => import(/* webpackChunkName: "HomePage" */ "@/pages/HomePage/HomePage.vue")
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/manage-my-data",
        name: "CCPA",
        component: CcpaPage
    },
    {
        path: "/about/cookie.html",
        name: "CookiePolicy",
        component: CookiePolicy
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.www.js